import React, { useEffect, useState, useContext } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../../services/helpers';
import { httpRequest } from '../../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../../parts/Loader';
import store from '../../../../services/store';
import images from '../../../../services/images';
import initTreeView from '../../../../services/initTreeView';
import StoreInfo from '../../../parts/StoreInfo';
import ProfileContext from '../../../../services/profileContext';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

export default function QuotationPrintViewPolarAir (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'quotation_single_label', 'Quotation');

    const { quotation_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.quotation_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
   
    useEffect(() => {
        initTreeView()
        if(quotation_id){
            fetchData(quotation_id)
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    function fetchData(quotation_id){
        if(!quotation_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/quotations/${quotation_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.quotation_date = new Date(res.quotation_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
            
            setTimeout(function(){
                //window.print()
            }, 2000);
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/quotations/list");
                }
            })
        }); 

    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                const num = Number(key) + 1
                return(
                <tr>
                    <td>{num}</td>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        <div><small>SKU: {data.product_code}</small></div>
                        {data.product_description ? <div className='mt-1'><small style={{whiteSpace: 'pre-line'}}>{data.product_description}</small></div> : ''}
                    </td>
                    {/* <td>{data.product_code}</td> */}
                    <td>{data.quantity}{data.unit_name ? ` ${data.unit_name}` : ''}</td>
                    <td>{helpers.formatCurrencyAmount(data.amount, default_currency)}</td>
                    {parseInt(discount_enabled) ? 
                    <td>
                        {helpers.formatCurrencyAmount(data.discount_amount, default_currency)}
                        <br/>
                        <small>{data.discount_name ? `(${data.discount_name})` : ''}</small>
                    </td> : ''
                    }
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                </tr>)

            })

            items.push(
                <>
                    <tr>
                        <td colSpan={5} className='text-right'>Total</td>
                        <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='text-right'>Downpayment (
                            <InputNumber 
                                suffix="%" 
                                size="small"
                                minFractionDigits={0}
                                maxFractionDigits={2}
                                min={0}
                                max={100}
                                placeholder="0%"
                                style={{ width: 'fit-content', display: 'inline-flex' }}
                                inputStyle={{ 
                                    width: 'fit-content',
                                    maxWidth: '40px', // Prevents overflow
                                    border: 'none', 
                                    boxShadow: 'none',
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    color: '#000000',
                                    textAlign: 'center'
                                }}
                            />)
                        </td>
                        <td>
                            <InputNumber 
                                mode="currency" 
                                currency="PHP" 
                                locale="en-PH"
                                size="small"
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                placeholder="₱0.00"
                                className='p-inputtext-sm'
                                inputClassName="text-dark"
                                style={{ width: 'fit-content', display: 'inline-flex' }}
                                inputStyle={{ 
                                    width: 'fit-content',
                                    minWidth: '50px', // Prevents layout jump when empty
                                    border: 'none', 
                                    boxShadow: 'none',
                                    paddingTop: 0,
                                    paddingBottom: 0
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='text-right'>Balance</td>
                        <td>
                            <InputNumber 
                                mode="currency" 
                                currency="PHP" 
                                locale="en-PH"
                                size="small"
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                placeholder="₱0.00"
                                className='p-inputtext-sm'
                                inputClassName="text-dark"
                                style={{ width: 'fit-content', display: 'inline-flex' }}
                                inputStyle={{ 
                                    width: 'fit-content',
                                    minWidth: '50px', // Prevents layout jump when empty
                                    border: 'none', 
                                    boxShadow: 'none',
                                    paddingTop: 0,
                                    paddingBottom: 0
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='text-right'>Monthly Payment (
                            <InputNumber 
                                suffix=" months" 
                                size="small"
                                minFractionDigits={0}
                                maxFractionDigits={2}
                                min={0}
                                max={100}
                                placeholder="0 month"
                                style={{ width: 'fit-content', display: 'inline-flex' }}
                                inputStyle={{ 
                                    width: 'fit-content',
                                    maxWidth: '100px', // Prevents overflow
                                    border: 'none', 
                                    boxShadow: 'none',
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    color: '#000000',
                                    textAlign: 'center'
                                }}
                            />)
                        </td>
                        <td>
                            <InputNumber 
                                mode="currency" 
                                currency="PHP" 
                                locale="en-PH"
                                size="small"
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                placeholder="₱0.00"
                                className='p-inputtext-sm'
                                inputClassName="text-dark"
                                style={{ width: 'fit-content', display: 'inline-flex' }}
                                inputStyle={{ 
                                    width: 'fit-content',
                                    minWidth: '50px', // Prevents layout jump when empty
                                    border: 'none', 
                                    boxShadow: 'none',
                                    paddingTop: 0,
                                    paddingBottom: 0
                                }}
                            />
                        </td>
                    </tr>
                </>
                    )
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    return (
        <div className="invoice p-4 mb-3 rounded">
        <Loader isLoading={loading}/>
            <div className="row">
                <div className="col-7">
                    <div className="d-flex justify-content-start">
                        <img src={images.polarair_logo} alt="Polar Air Logo" className="img-fluid" style={{width: '70px'}} />
                        <div className='ml-3'>
                            <h4 className="mb-0 font-weight-bold" style={{color: '#1789d0', borderBottom: '1px solid #1789d0'}}>POLAR-AIR AIRCON</h4>
                            {/* <p className='font-italic mb-0 text-sm'>A Registered Trademark of Polar Home Enterprises OPC</p> */}
                            <small className='font-italic'>A Registered Trademark of Polar Home Enterprises OPC</small>
                        </div>
                    </div>
                </div>
                <div className="col-5 text-right text-muted">
                    <div><small>Matias Bldg. National Highway, Isulan, Sultan Kudarat</small></div>
                    <div><small>Mobile: 09984046135</small></div>
                    <div><small>Website: polar-air.com</small></div>
                </div>
            </div>

            <div  className="py-2 mb-3" style={{color: '#1789d0', borderBottom: '1px solid #1789d0'}} />

            <div className='mb-3'>
                <table className='tables table-borderlesss table-sm mb-3'>
                    <tbody>
                        <tr>
                            <td className='p-0 pr-4'>Date:</td>
                            <td className='p-0'>{record_loaded ? helpers.formatDisplayDate(record_data.quotation_date) : '---'}</td>
                        </tr>
                        <tr>
                            <td className='p-0 pr-4'>No:</td>
                            <td className='p-0'>{record_data.quotation_no}</td>
                        </tr>
                        <tr>
                            <td className='p-0 pr-4'>To:</td>
                            <td className='p-0'><b>{record_data.customer_name}</b></td>
                        </tr>
                        <tr>
                            <td className='p-0 pr-4'>Subject:</td>
                            <td className='p-0'>Quotation for the supply, delivery and installation of aircon units</td>
                        </tr>
                    </tbody>
                </table>

                <div>
                    Thank you for the opportunity to serve you. We are pleased to submit our quotation for the <b>supply, delivery and installation of air conditioning units</b> per the details below. Our commitment is after-sales service first, sales second.
                </div>
            </div>

            {/* <div className="d-flex justify-content-between mb-3">
                <StoreInfo store={record_data.store_info} />

                <div className='text-right'>
                    <h2><strong>{helpers.capitalizeString(single_label)}</strong></h2>
                    <h5 className='mb-0'>{record_data.quotation_no ? `${record_data.quotation_no}` : '---'}</h5>
                </div>
            </div> */}

            {/* <div className="row">
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Bill To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.customer_name}</b></p>
                        <p className='mb-0'>{record_data.billing_address}</p>
                        <p className='mb-0'>{record_data.billing_phone}</p>
                    </div>
                </div>
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Ship To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                        <p className='mb-0'>{record_data.shipping_address}</p>
                        <p className='mb-0'>{record_data.shipping_phone}</p>
                    </div>
                </div>
                <div className="col-4 text-lg-right mb-2">
                    <table className='table table-borderless table-sm'>
                        <tbody>
                            <tr>
                                <td className='py-0'><b>Date:</b></td>
                                <td className='py-0'>{record_loaded ? helpers.formatDisplayDate(record_data.quotation_date) : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Version:</b></td>
                                <td className='py-0'>{record_data.quote_version ? record_data.quote_version : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Payment Terms:</b></td>
                                <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Sales Person:</b></td>
                                <td className='py-0'>{record_data.sales_person ? record_data.sales_person : '---'}</td>
                            </tr>
                            {
                                record_data.order_status_id == 4
                                ?
                                <tr>
                                    <td className='py-0'><b>Cancellation Reason:</b></td>
                                    <td className='py-0'>{record_data.reason}</td>
                                </tr> : ''
                            }
                        </tbody>
                    </table>
                </div>
            </div> */}

            <style>{`
            @media print {
                /* 1. Force color adjustment on the table elements */
                .custom-print-table, 
                .custom-print-table thead, 
                .custom-print-table tr, 
                .custom-print-table th {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                }

                /* 2. Override Bootstrap's print resets */
                .table.custom-print-table thead th {
                background-color: #1789d0 !important;
                color: #ffffff !important;
                }
            }
            `}</style>

            <div className='table-responsive'>
                <table className='table table-bordered table-sm border-bottom custom-print-table'>
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>No</th>
                            <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>Item Description / Activity</th>
                            <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>Quantity</th>
                            <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>Unit Price</th>
                            {parseInt(discount_enabled) ? (
                                <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>Discount</th>
                            ) : null}
                            <th style={{ backgroundColor: '#1789d0', color: '#fff' }}>Total</th>
                        </tr>
                    </thead>
                    {table_items}
                </table>
            </div>

            <div>
                <label className="font-weight-bolds" style={{color: '#1789d0'}}>Warranty</label>
                <div
                    className='mb-3'
                    contentEditable="plaintext-only"
                    suppressContentEditableWarning
                    style={{
                        outline: 'none',
                        width: '100%',
                        color: '#000000',
                        paddingTop: 0,
                        paddingBottom: 0,
                        cursor: 'text'
                    }}
                >
                    1 year Parts & Labor · 3 years PCB · 5 years Compressor (per manufacturer terms)
                </div>

                <label className="font-weight-bolds" style={{color: '#1789d0'}}>Payment Terms</label>
                <div
                    className='mb-3'
                    contentEditable="plaintext-only"
                    suppressContentEditableWarning
                    style={{
                        outline: 'none',
                        width: '100%',
                        color: '#000000',
                        paddingTop: 0,
                        paddingBottom: 0,
                        cursor: 'text'
                    }}
                >
                    20% downpayment upon confirmation; 80% balance after complete installation.
                </div>

                <label className="font-weight-bolds" style={{color: '#1789d0'}}>Included in the Quotation</label>
                <div
                    className='mb-3'
                    contentEditable="plaintext-only"
                    suppressContentEditableWarning
                    style={{
                        outline: 'none',
                        width: '100%',
                        color: '#000000',
                        paddingTop: 0,
                        paddingBottom: 0,
                        cursor: 'text'
                    }}
                >
                    Supply and delivery of units · Standard installation up to 10 ft piping per unit · Outdoor bracket · Vacuuming and commissioning · Testing
                </div>

                <label className="font-weight-bolds" style={{color: '#1789d0'}}>Not Included</label>
                <div
                    className='mb-3'
                    contentEditable="plaintext-only"
                    suppressContentEditableWarning
                    style={{
                        outline: 'none',
                        width: '100%',
                        color: '#000000',
                        paddingTop: 0,
                        paddingBottom: 0,
                        cursor: 'text'
                    }}
                >
                    Electrical supply line and breaker · Carpentry or civil works · Piping in excess of 10 ft (billed per foot)
                </div>

                <div className='mb-4'>
                    Respectfully yours,<br/>
                    Thank You
                </div>
                {/* <InputTextarea 
                    value='1 year Parts & Labor · 3 years PCB · 5 years Compressor (per manufacturer terms)'
                    autoResize
                    rows={2}
                    placeholder="N/A"
                    className="p-inputtext-sm"
                    style={{ 
                        width: '100%',             // Spans full container width
                        display: 'block',
                        border: 'none', 
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        color: '#000000',
                        resize: 'none'             // Prevents drag resizer handle
                    }}
                /> */}

                <div>
                    <b>{account?.user?.display_name ?? '[Profile Name]'}</b><br/>
                    Sales Representative
                </div>
            </div>

            {/* <div className='row'>
                <div className="col-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                <div className="col-5 mb-2 border p-2">
                    <table className='table table-sm table-borderless mb-0'>
                        <tbody>
                            <tr>
                                <td className='border-top-0'><b>Sub Total</b></td>
                                <td className='border-top-0'>{computeSubTotals()}</td>
                            </tr>
                            {parseInt(discount_enabled) ?
                            <tr>
                                <td><b>Total Discount</b></td>
                                <td>{parseFloat(record_data.total_discount) > 0 ? helpers.formatCurrencyAmount(record_data.total_discount, default_currency) : helpers.formatCurrencyAmount(0, default_currency)}</td>
                            </tr> : ''
                            }
                            <tr>
                                <td><b>Shipping Fee</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.shipping_fee, default_currency)}</td>
                            </tr>
                            {parseInt(tax_enabled) ?
                            <tr>
                                <td><b>Total Tax</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.total_tax, default_currency)}</td>
                            </tr> : ''
                            }
                            <tr className='bg-dark'>
                                <td><b>Total</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> */}

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>This is a system-generated report. Powered by Etyel ERP.</small>
                </div>
            </div>
        </div>
    )
}